
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaipunecabbooking() {



    const cardData =
    {
        keyword: 'Mumbai Pune Cab Booking',
        heading: 'Skyline Cabs: Mumbai Pune Cab Booking',
        headingDescription: 'Skyline Cabs makes Mumbai Pune Cab Booking easy and convenient for a comfortable travel experience. Whether you are traveling for business, a weekend getaway, or airport transfers, our booking process is simple, quick, and secure. Choose from a variety of well-maintained vehicles and enjoy timely pickups, professional drivers, and affordable fares. With 24/7 availability and customer-centric service, Skyline Cabs ensures your Mumbai to Pune journey is smooth and stress-free. Book your Mumbai Pune cab today and experience reliable and comfortable travel.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Taxi Fare Return",
      "description": "Skyline Cabs offers affordable return taxi fares for Mumbai to Pune trips. Book a round trip and enjoy fixed pricing that includes all charges such as tolls, fuel, and driver fees. Choose from sedans, Innova Crysta, or Ertiga for comfort and convenience."
    },
    {
      "name": "Mumbai to Wanwadi Cab Service",
      "description": "Travel from Mumbai to Wanwadi with Skyline Cabs for a seamless and comfortable ride. Our cab services include trained drivers, clean vehicles, and reliable punctuality for a smooth journey every time."
    },
    {
      "name": "Mumbai to Mundwa Cab Service",
      "description": "Skyline Cabs provides dependable taxi services from Mumbai to Mundwa, with a variety of vehicle options to suit your preferences. Whether it's a one-way or round trip, our services are tailored for comfort and safety."
    },
    {
      "name": "Mumbai to Wadgaon Sheri Cab Service",
      "description": "Choose Skyline Cabs for your journey from Mumbai to Wadgaon Sheri. We offer affordable and reliable taxi services with experienced chauffeurs, flexible booking options, and clean, well-maintained vehicles."
    },
    {
      "name": "Mumbai to Nigdi Cab Service",
      "description": "Skyline Cabs provides fast and comfortable cab services from Mumbai to Nigdi. Whether you're traveling for business or leisure, we ensure punctual pick-ups and hassle-free travel with a fleet of well-maintained vehicles."
    },
    {
      "name": "Mumbai to Swargate Cab",
      "description": "Book a taxi from Mumbai to Swargate with Skyline Cabs. We offer easy online booking, transparent pricing, and a choice of vehicles including Innova Crysta and Ertiga, providing a reliable and smooth travel experience."
    },
    {
      "name": "Mumbai to Pune Station Cab",
      "description": "Skyline Cabs offers dedicated cab services from Mumbai to Pune Railway Station. With professional drivers, on-time pickups, and fixed fares, we ensure a hassle-free travel experience to your destination."
    },
    {
      "name": "Mumbai to Shivaji Nagar Cab",
      "description": "Travel from Mumbai to Shivaji Nagar with Skyline Cabs for a comfortable and safe journey. We provide affordable pricing, door-to-door service, and a variety of vehicles including sedans and SUVs to choose from."
    },
    {
      "name": "Mumbai Pune Taxi Booking",
      "description": "Book your Mumbai to Pune taxi with Skyline Cabs in advance or on-demand. Our booking system is user-friendly and ensures a seamless experience with options for one-way, round-trip, and multi-day bookings."
    },
    {
      "name": "Mumbai to Pune Cab",
      "description": "Skyline Cabs provides comfortable and reliable taxi services from Mumbai to Pune. Choose from a range of vehicles, including sedans, Ertiga, and Innova Crysta, to make your trip smooth and hassle-free."
    },
    {
      "name": "Pune to Mumbai Cabs",
      "description": "Book a taxi from Pune to Mumbai with Skyline Cabs for a comfortable and timely journey. Our vehicles are well-maintained, and our drivers are experienced to provide you with a safe travel experience."
    },
    {
      "name": "Mumbai to Pune Cab Service",
      "description": "Skyline Cabs offers premium taxi services from Mumbai to Pune with competitive pricing and high-quality service. Whether for a one-way trip or round-trip, our experienced drivers will ensure a smooth ride."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Need a ride from Pune to Mumbai? Skyline Cabs offers fast, reliable, and comfortable taxi services with door-to-door service, transparent pricing, and multiple vehicle options to fit your needs."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      "description": "Skyline Cabs provides dedicated taxi services between Pune and Mumbai, ensuring safe and comfortable travel for both one-way and round-trip journeys. Book a cab today for a seamless experience."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Book your Pune to Mumbai cab with Skyline Cabs for a reliable and affordable ride. Our online booking platform makes it easy to book in advance or on short notice, with multiple payment options."
    },
    {
      "name": "Cab Service Mumbai to Pune",
      "description": "Skyline Cabs offers dependable cab services from Mumbai to Pune, ensuring punctual arrivals, experienced chauffeurs, and a smooth travel experience. Our fleet includes sedans, SUVs, and luxury cars for your comfort."
    },
    {
      "name": "Mumbai to Pune Taxi Charges",
      "description": "Skyline Cabs offers competitive and transparent pricing for Mumbai to Pune taxi services. Our fares include all charges, such as tolls, fuel, and driver fees, with no hidden costs."
    },
    {
      "name": "Mumbai to Pune Innova Cab",
      "description": "For a comfortable, spacious, and luxurious ride from Mumbai to Pune, choose an Innova Crysta with Skyline Cabs. Our fleet of well-maintained vehicles ensures you have a smooth and pleasant journey."
    },
    {
      "name": "Mumbai to Pune Innova Crysta on Rent",
      "description": "Skyline Cabs offers the Innova Crysta on rent for your Mumbai to Pune trip. Rent a premium vehicle that provides ample space, comfort, and luxury for a relaxed journey with family, friends, or business colleagues."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Taxi Fare Return", "Mumbai to Wanwadi Cab Service"],
    ["Mumbai to Mundwa Cab Service", "Mumbai to Wadgaon Sheri Cab Service"],
    ["Mumbai to Nigdi Cab Service", "Mumbai to Swargate Cab"],
    ["Mumbai to Pune Station Cab", "Mumbai to Shivaji Nagar Cab"],
    ["Mumbai Pune Taxi Booking", "Mumbai to Pune Cab"],
    ["Pune to Mumbai Cabs", "Mumbai to Pune Cab Service"],
    ["Pune to Mumbai Cab Service", "Pune Mumbai Taxi Service"],
    ["Pune to Mumbai Cab Booking", "Cab Service Mumbai to Pune"],
    ["Mumbai to Pune Taxi Charges", "Mumbai to Pune Innova Cab"],
    ["Mumbai to Pune Innova Crysta on Rent", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Easy Online Booking for Mumbai to Pune Cabs",
        "WhyChoosedescription": "Booking your Mumbai to Pune cab has never been easier with Skyline Cabs. Our user-friendly website and mobile app allow you to book a cab anytime, anywhere, with instant confirmation and live tracking features for a seamless experience from start to finish."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained, air-conditioned vehicles ensures a comfortable ride for your journey from Mumbai to Pune. Whether you're traveling solo, with family, or in a group, we have sedans, SUVs, and luxury cars to cater to your preferences and comfort."
    },
    {
        "WhyChooseheading": "Professional Drivers for a Smooth Ride",
        "WhyChoosedescription": "Skyline Cabs drivers are highly skilled, background-checked, and well-versed in the Mumbai to Pune route. They prioritize your comfort and safety, ensuring you arrive at your destination on time, every time, with a smooth and stress-free ride."
    },
    {
        "WhyChooseheading": "Transparent Pricing and No Hidden Charges",
        "WhyChoosedescription": "With Skyline Cabs, you get upfront, transparent pricing. There are no hidden fees or surprises—just a clear, affordable fare for your Mumbai to Pune trip. Our pricing structure is competitive and designed to offer the best value for quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for On-Demand Travel",
        "WhyChoosedescription": "No matter when you need a ride, Skyline Cabs is available 24/7. Whether you're planning a last-minute trip, catching an early flight, or returning late at night, you can book your Mumbai to Pune cab anytime through our easy-to-use online platform."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "Choose the best vehicle for your journey, whether it's a compact sedan for a solo trip or a spacious SUV for a family or business group. Skyline Cabs offers a variety of well-maintained options, ensuring a comfortable, hassle-free ride from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Secure Online Payment and Booking",
        "WhyChoosedescription": "Booking your Mumbai to Pune cab online is secure and convenient. Our platform supports a variety of payment methods, including credit cards, debit cards, and online wallets, ensuring that your transaction is simple and safe."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Rides Every Time",
        "WhyChoosedescription": "Skyline Cabs prioritizes your safety. All our vehicles are sanitized after every ride, and our drivers follow strict safety protocols. Enjoy a safe, clean, and secure ride from Mumbai to Pune, whether you're traveling for business, leisure, or personal reasons."
    }
]
























    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a Mumbai to Pune cab online with Skyline Cabs?',
            answer:
                'Booking is easy! Just visit our website or use the Skyline mobile app, enter your pickup location in Mumbai and drop-off in Pune, choose your preferred car, and confirm your booking instantly.',
        },
        {
            id: 2,
            question: 'Can I schedule my online cab in advance?',
            answer:
                'Yes, you can pre-book your Mumbai to Pune cab online for any future date and time. We recommend booking in advance for better availability, especially during weekends or holidays.',
        },
        {
            id: 3,
            question: 'Is online payment available for booking?',
            answer:
                'Yes, we support secure online payment options including UPI, credit/debit cards, and net banking. You’ll receive an instant confirmation after successful payment.',
        },
        {
            id: 4,
            question: 'What kind of vehicles can I book online for this route?',
            answer:
                'You can book from a wide range of cars including Sedans, SUVs, Ertiga, Innova Crysta, and even luxury options — all available directly on our website or app.',
        },
        {
            id: 5,
            question: 'Can I track my cab after online booking?',
            answer:
                'Yes, once your booking is confirmed, you’ll receive real-time tracking updates along with driver and vehicle details — ensuring full transparency and security.',
        },
        {
            id: 6,
            question: 'Are there any cancellation charges for online bookings?',
            answer:
                'We offer flexible cancellation policies. If you cancel within the free window, there are no charges. Please refer to our cancellation policy during booking for exact details.',
        },
        {
            id: 7,
            question: 'Is the fare shown online final and inclusive of all charges?',
            answer:
                'Yes, the fare you see online includes tolls, taxes, and driver charges. There are no hidden fees — complete transparency guaranteed.',
        },
        {
            id: 8,
            question: 'Can I book a return trip online?',
            answer:
                'Definitely. While booking your Mumbai to Pune cab online, simply select the round-trip option and provide your return date/time.',
        },
        {
            id: 9,
            question: 'What if I need to make changes after booking online?',
            answer:
                'You can easily modify your ride details through our website or app. Our customer support is also available 24/7 for any assistance.',
        },
        {
            id: 10,
            question: 'Why book a Mumbai to Pune cab online with Skyline?',
            answer:
                'Skyline Cabs offers quick online booking, professional drivers, clean cars, transparent pricing, and 24x7 customer support — making your intercity travel effortless and dependable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sameer Kulkarni",
            rating: 5,
            review: "Booked a cab online from Mumbai to Pune through Skyline’s website. The whole process took less than 2 minutes and everything went smoothly. Super convenient and reliable!"
        },
        {
            name: "Miss. Sneha Pawar",
            rating: 4,
            review: "Loved how simple it was to book my ride online. The cab arrived on time, the driver was courteous, and the trip to Pune was really comfortable. Highly recommended!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Pune Cab Booking",
  "image": "https://skylinecabs.com/assets/images/mumbai-pune-cab-booking.jpg",
  "description": "Mumbai Pune cab booking made easy with Skyline Cabs. Get instant confirmation, 24/7 AC taxi service, and verified drivers for one-way or round-trip rides in sedans or SUVs.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8491"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-pune-cab-booking"
  }
};

   
      


    return (
        <div>

<Helmet>
  <title>Mumbai Pune Cab Booking | Instant Confirmation | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Mumbai Pune cab booking made easy with Skyline Cabs. Get instant confirmation, 24/7 AC taxi service, and verified drivers for one-way or round-trip rides in sedans or SUVs." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Pune Cab Booking, Cab Booking Mumbai to Pune, Online Cab Mumbai to Pune, One-Way Cab Mumbai Pune, Round Trip Taxi Mumbai to Pune, AC Cab Booking Mumbai Pune, Skyline Cabs Mumbai Pune, SUV Taxi Mumbai to Pune, Instant Cab Booking Mumbai Pune, 24/7 Taxi Booking Mumbai Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/71.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaipunecabbooking;